import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const approveGrammarPointsV1DataSchemaDefinition = z.object({
  updated: z.number().int().min(0),
  approved: z.boolean(),
});

export const approveGrammarPointsV1DataSchema: typeof approveGrammarPointsV1DataSchemaDefinition =
  approveGrammarPointsV1DataSchemaDefinition;

export type IApproveGrammarPointsV1Data = z.infer<typeof approveGrammarPointsV1DataSchema>;

export const approveGrammarPointsV1ResponseSchema: z.ZodSchema<IAPI<IApproveGrammarPointsV1Data>> =
  createApiResponseSchema(approveGrammarPointsV1DataSchema) as z.ZodSchema<
    IAPI<IApproveGrammarPointsV1Data>
  >;

export type IApproveGrammarPointsV1Response = IAPI<IApproveGrammarPointsV1Data>;
